import axios from "axios";

export function authHeader() {
  // return authorization header with jwt token
  let token = JSON.parse(localStorage.getItem("token"));
  if (token && token.access_token) {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + token.access_token;
    return {
      Authorization: "Bearer " + token.access_token,
      Accept: "application/json",
    };
  } else {
    return {};
  }
}
